import { useEffect, useState } from 'react';
import config from '../../common/config';
import SvgMovie from '../../../components/SvgMovie';

import './styles/Digest11.less';

let timeoutDelayPlay: any;
let timeoutPlayText: any;
const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playText, setPlayText] = useState(false);
  const slide: any = config.slides[seq];

  useEffect(() => {
    if (timeoutDelayPlay) {
      clearTimeout(timeoutDelayPlay);
      timeoutDelayPlay = null;
    }
    if (timeoutPlayText) {
      clearTimeout(timeoutPlayText);
      timeoutPlayText = null;
    }

    if (play) {
      timeoutDelayPlay = setTimeout(() => {
        setDelayPlay(true);
      }, 300);

      timeoutPlayText = setTimeout(() => {
        setPlayText(true);
      }, 500);
    } else {
      // 恢复初始化状态
      setDelayPlay(false);
      setPlayText(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <SvgMovie
        className="full-screen-svg"
        src={config.slides[seq].svgMovie}
        play={delayPlay}
        onComplete={(e: any) => {
          // setPlayText(true);
        }}
      />
      <div className={`digest digest-${seq}`}>
        <div className={`text-block ${playText ? 'ani-fade-in' : ''}`}>
          <SvgMovie
            className="svg-in-block"
            src={slide.svgs[0]}
            play={playText}
            onDataLoaded={onDataLoaded}
          />
          <div className="titles">
            <div className="title title-primary">业务落地周期</div>
          </div>
          <div className="description">
            <div>覆盖B端系统的大部分基础组件，无需重复造轮子，</div>
            <div>更无需浪费时间造轮子，大大缩短新应用、</div>
            <div>新页面的搭建周期。</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
